module.exports = __webpack_public_path__ + "img/canbadge_egg_w46mm_trimmark.9afb2838.png";